export class BookingSearchFailedError extends Error {
  constructor(message = 'Failed to search bookings') {
    super(message);
    this.name = 'BookingSearchFailedError';
  }
}
